import { render, staticRenderFns } from "./AddLinkBtn.vue?vue&type=template&id=48f5783e&scoped=true&"
import script from "./AddLinkBtn.vue?vue&type=script&lang=js&"
export * from "./AddLinkBtn.vue?vue&type=script&lang=js&"
import style0 from "./AddLinkBtn.vue?vue&type=style&index=0&id=48f5783e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f5783e",
  null
  
)

export default component.exports